import { useContext } from 'react';
import { ToggleButton, makeStyles, tokens } from '@fluentui/react-components';
import { BrainSparkleRegular } from '@fluentui/react-icons';

import { EItemScreenMode, useItemScreenStore } from '@modules/items';
import { SignInContext } from '@modules/users';

import { isAiFindingsVisible } from '../helpers';

const useStyles = makeStyles({
  label: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: tokens.spacingHorizontalXS,
  },
  alertIcon: {
    color: tokens.colorBrandForeground1,
  },
  alertText: {
    color: tokens.colorPaletteRedForeground1,
    fontWeight: tokens.fontWeightSemibold,
  },
});

type TProps = {
  documentName?: string;
};

const MockAiFindingsButton = ({ documentName }: TProps) => {
  const { organization } = useContext(SignInContext);
  const { screenMode, setScreenMode } = useItemScreenStore();
  const classes = useStyles();

  const isVisible = isAiFindingsVisible(organization.mock?.isAiEnabled, documentName);
  const isOpen = screenMode === EItemScreenMode.MOCK_AI_FINDINGS;

  if (!isVisible) return null;

  return (
    <ToggleButton
      size="small"
      checked={isOpen}
      icon={<BrainSparkleRegular className={classes.alertIcon} />}
      onClick={() => setScreenMode(isOpen ? undefined : EItemScreenMode.MOCK_AI_FINDINGS)}
    >
      <span className={classes.label}>
        <span>AI findings</span>
        <span className={classes.alertText}>(!)</span>
      </span>
    </ToggleButton>
  );
};

export default MockAiFindingsButton;
